import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { useHeaderFooter } from '../../hooks';

import './index.scss';
import messages from './messages';

import tlunaImg from '../../img/tluna-pic.jpeg';
import heroImg from '../../img/presentedBy/PRESENTEDBY-LWC.jpg';

interface PresentedByProps {
  children?: React.ReactNode
}
const PresentedBy: React.FC<PresentedByProps> = ({ children }) => {
  const { headerContent, footerContent } = useHeaderFooter(children);
  const intl = useIntl();

  const LEARN_BASE_URL = getConfig().LMS_BASE_URL;

  return (
    <>
      <input type="hidden" id="anPageName" name="page" defaultValue="about" />
      <div className="container-center-horizontal">
        <div className="about screen contact">
          <div className="homepage ">
            {headerContent}
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group-1">
                  <img
                    className="overlap-group-item"
                    src={heroImg}
                    alt={intl.formatMessage(messages.heroImageAlt)}
                  />
                  <h1 className="about-us recklessneue-regular-normal-white-100-1px">
                    <span className="recklessneue-regular-normal-white-100-1px">
                      {intl.formatMessage(messages.title)}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="course-overview-text">
            <div className="overlap-group5 pres-overlap">
              <p className="lorem-ipsum-dolor-si-1 neuehaasgroteskdisplaypro-45-light-congress-blue-24px pres-desc">
                {intl.formatMessage(messages.description)}
              </p>
            </div>
          </div>
          <div className="tutor-list tutor-list-custom">
            <NavLink to="/profile-guide/tadeyinka">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+106+2023+type@asset+block@290305093-e34f0068-e753-46cd-89c3-b6b82d5f6129.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffAdeyinka)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/temmie">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+106+2023+type@asset+block@290305099-3ad96920-2273-4bbd-b7db-c32092a3b920.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffEmmie)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tedward">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+100+2023+type@asset+block@290305097-ec9e7175-4bfe-407f-8492-40fe9c1928cf.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffEdward)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tkaty">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+104+2023+type@asset+block@290305090-dc46c72d-5b7a-4404-9ff4-6b79c563d41c.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffKaty)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tgerald">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+106+2023+type@asset+block@290305094-0283dc62-b8fa-4249-a4fe-dbce00294c57.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffGerald)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tveronica">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+103+2023+type@asset+block@290305091-57ca89f9-8e6c-4ea2-a3a2-2b6695c8f01d.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffVeronica)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tjoann">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+103+2023+type@asset+block@290305107-1729144f-8f22-4554-8ce0-800e01a66f6f.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffJoann)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tlina">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+106+2023+type@asset+block@290305103-292d2c85-53be-4603-855b-8533d3625fa7.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffLina)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tmatthew">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url(${LEARN_BASE_URL}/asset-v1:Legatum+104+2023+type@asset+block@290305104-cfcaaf14-bf89-4703-8cf4-81c2f9832b1d.jpeg)`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffMatthew)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tanjali">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{
                    backgroundImage: `url("${LEARN_BASE_URL}/asset-v1:Legatum+100+2023+type@asset+block@290305096-9887a801-f992-40e3-9e4d-746b21373923.jpeg")`,
                  }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffAnjali)}
                </div>
              </div>
            </NavLink>
            <NavLink to="/profile-guide/tluna">
              <div className="badge-01 badge">
                <div
                  className="frame-30"
                  style={{ backgroundImage: `url("${tlunaImg}")` }}
                />
                <div className="name neuehaasgroteskdisplaypro-45-light-congress-blue-38px">
                  {intl.formatMessage(messages.staffLuna)}
                </div>
              </div>
            </NavLink>
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default PresentedBy;
